(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-showcase"] && !Shopify.designMode) return;
  try {
    
  const initializeContactShowcaseUploads = (root = document) => {
    root.querySelectorAll('.contact-showcase__file-input').forEach((input) => {
      if (input.dataset.fileInputReady === 'true') return;
      input.dataset.fileInputReady = 'true';
      const fileName = input.closest('.contact-showcase__file-control')?.querySelector('[data-file-name]');
      if (!fileName) return;
      input.addEventListener('change', () => {
        fileName.textContent = input.files?.[0]?.name || fileName.dataset.emptyLabel;
      });
    });
  };

  initializeContactShowcaseUploads();
  document.addEventListener('shopify:section:load', (event) => initializeContactShowcaseUploads(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["designer-category-links"] && !Shopify.designMode) return;
  try {
    
  function initializeDesignerCategoryScrollers(root = document) {
    root.querySelectorAll('[data-designer-category-scroller]').forEach((scroller) => {
      if (scroller.dataset.dragReady === 'true') return;
      scroller.dataset.dragReady = 'true';
      let pointerId;
      let startX = 0;
      let startScrollLeft = 0;
      let moved = false;
      let dragging = false;

      scroller.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        pointerId = event.pointerId;
        startX = event.clientX;
        startScrollLeft = scroller.scrollLeft;
        moved = false;
        dragging = false;
      });

      scroller.addEventListener('pointermove', (event) => {
        if (event.pointerId !== pointerId) return;
        const distance = event.clientX - startX;
        if (!dragging && Math.abs(distance) <= 6) return;
        if (!dragging) {
          dragging = true;
          moved = true;
          scroller.classList.add('is-dragging');
          scroller.setPointerCapture(pointerId);
        }
        event.preventDefault();
        scroller.scrollLeft = startScrollLeft - distance;
      });

      const finishDrag = (event) => {
        if (event.pointerId !== pointerId) return;
        if (dragging && scroller.hasPointerCapture(pointerId)) scroller.releasePointerCapture(pointerId);
        pointerId = undefined;
        dragging = false;
        scroller.classList.remove('is-dragging');
      };

      scroller.addEventListener('pointerup', finishDrag);
      scroller.addEventListener('pointercancel', finishDrag);
      scroller.addEventListener('click', (event) => {
        if (!moved) return;
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      }, true);
    });
  }

  initializeDesignerCategoryScrollers();
  document.addEventListener('shopify:section:load', (event) => initializeDesignerCategoryScrollers(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-complete-project"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.fh-related[data-url]').forEach(s=>{if(s.querySelector('.fh-related__grid').children.length)return;fetch(s.dataset.url).then(r=>r.text()).then(t=>{const d=document.createElement('div');d.innerHTML=t;const n=d.querySelector('.fh-related__grid');if(n)s.querySelector('.fh-related__grid').innerHTML=n.innerHTML})});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-hero"] && !Shopify.designMode) return;
  try {
    
function initFHHomeHero(root){
  if(!root||root.dataset.fhReady)return;
  root.dataset.fhReady='true';
  const slides=[...root.querySelectorAll('[data-fh-slide]')];
  const tabs=[...root.querySelectorAll('[data-fh-tab]')];
  if(slides.length<2)return;
  let current=Math.min(Number(root.dataset.initial)||0,slides.length-1);
  let timer;
  let touchX=0;
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const delay=Math.max(3000,Number(root.dataset.delay)||6500);
  const counter=root.querySelector('[data-fh-counter]');
  function stop(){window.clearInterval(timer);timer=undefined}
  function start(){stop();if(!reduced.matches&&!root.matches(':hover'))timer=window.setInterval(()=>show(current+1,false),delay)}
  function show(next,manual){
    current=(next+slides.length)%slides.length;
    slides.forEach((slide,index)=>{
      const active=index===current;
      slide.classList.toggle('is-active',active);
      slide.setAttribute('aria-hidden',String(!active));
      slide.inert=!active;
    });
    tabs.forEach((tab,index)=>{tab.classList.toggle('is-active',index===current);tab.setAttribute('aria-current',String(index===current))});
    if(counter)counter.textContent=String(current+1).padStart(2,'0')+' / '+String(slides.length).padStart(2,'0');
    if(manual)start();
  }
  tabs.forEach(tab=>tab.addEventListener('click',()=>show(Number(tab.dataset.target),true)));
  root.querySelector('[data-fh-prev]')?.addEventListener('click',()=>show(current-1,true));
  root.querySelector('[data-fh-next]')?.addEventListener('click',()=>show(current+1,true));
  root.addEventListener('pointerenter',stop);
  root.addEventListener('pointerleave',start);
  root.addEventListener('touchstart',event=>{touchX=event.changedTouches[0].screenX},{passive:true});
  root.addEventListener('touchend',event=>{const delta=event.changedTouches[0].screenX-touchX;if(Math.abs(delta)>55)show(current+(delta<0?1:-1),true)},{passive:true});
  root.addEventListener('fh:destroy',stop,{once:true});
  root.fhSelectBlock=blockId=>{const index=slides.findIndex(slide=>slide.dataset.blockId===blockId);if(index>=0){stop();show(index,false)}};
  show(current,false);
  start();
}
document.querySelectorAll('[data-fh-hero]').forEach(initFHHomeHero);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-fh-hero]').forEach(initFHHomeHero));
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-fh-hero]').forEach(root=>root.dispatchEvent(new Event('fh:destroy'))));
document.addEventListener('shopify:block:select',event=>event.target.closest('[data-fh-hero]')?.fhSelectBlock?.(event.detail.blockId));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-product-application"] && !Shopify.designMode) return;
  try {
    function fhSliders(root=document){root.querySelectorAll('[data-fh-slider]').forEach(s=>{if(s.dataset.ready)return;s.dataset.ready='true';const slides=[...s.querySelectorAll('[data-slide]')],dots=[...s.querySelectorAll('[data-dot]')];let i=0;const show=n=>{i=(n+slides.length)%slides.length;slides.forEach((x,k)=>x.classList.toggle('is-active',k===i));dots.forEach((x,k)=>x.classList.toggle('is-active',k===i));s.querySelector('[data-current]').textContent=String(i+1).padStart(2,'0')};s.querySelector('[data-prev]')?.addEventListener('click',()=>show(i-1));s.querySelector('[data-next]')?.addEventListener('click',()=>show(i+1));dots.forEach((d,k)=>d.addEventListener('click',()=>show(k)));let x;s.addEventListener('touchstart',e=>x=e.touches[0].clientX,{passive:true});s.addEventListener('touchend',e=>{const d=e.changedTouches[0].clientX-x;if(Math.abs(d)>50)show(i+(d<0?1:-1))},{passive:true})})}fhSliders();document.addEventListener('shopify:section:load',e=>fhSliders(e.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-product-context"] && !Shopify.designMode) return;
  try {
    if(!window.fhContextVideoBound){document.addEventListener('click',event=>{const button=event.target.closest('[data-fh-context-video-play]');if(!button)return;const media=button.closest('.fh-context__media');const videoId=button.dataset.videoId;if(!media||!videoId)return;const iframe=document.createElement('iframe');iframe.src=`https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0`;iframe.title=button.dataset.videoTitle||'YouTube video';iframe.allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';iframe.allowFullscreen=true;iframe.referrerPolicy='strict-origin-when-cross-origin';media.replaceChildren(iframe)});window.fhContextVideoBound=true}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.isOpen = false;
      this.onButtonClick = this.onButtonClick.bind(this);
      this.onContainerKeyUp = this.onContainerKeyUp.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);

      this.elements.button?.addEventListener('click', this.onButtonClick);
      this.addEventListener('keyup', this.onContainerKeyUp);
      document.addEventListener('click', this.onDocumentClick);

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    disconnectedCallback() {
      this.elements.button?.removeEventListener('click', this.onButtonClick);
      this.removeEventListener('keyup', this.onContainerKeyUp);
      document.removeEventListener('click', this.onDocumentClick);
    }

    hidePanel() {
      if (!this.elements.button || !this.elements.panel || !this.isOpen) return;
      this.isOpen = false;
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    showPanel() {
      if (!this.elements.button || !this.elements.panel || this.isOpen) return;
      this.isOpen = true;
      this.elements.button.setAttribute('aria-expanded', 'true');
      this.elements.panel.removeAttribute('hidden');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    onButtonClick(event) {
      event.preventDefault();

      if (!this.elements.button || !this.elements.panel) return;

      if (this.isOpen) {
        this.hidePanel();
      } else {
        this.showPanel();
      }
    }

    onDocumentClick(event) {
      if (this.isOpen && !this.contains(event.target)) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      if (this.header) {
        observer.observe(this.header);
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
        this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-always-sticky');
        this.header.classList.remove('color-background-3');
        this.header.style.transition = 'background var(--duration-short), transform var(--duration-default)';
      }

      if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
        this.header.classList.remove('shopify-section-header-sticky');
        this.header.style.transition = 'background var(--duration-short)';
        if (this.header.classList.contains('color-background-1')) {
          this.header.classList.add('color-background-3');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden', 'color-background-3');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (this.header.classList.contains('color-background-1')) {
        this.header.classList.add('color-background-3');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (this.disclosures) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }
      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      if (this.disclosureLists) {
        this.disclosureLists.forEach((disclosureList) => {
          disclosureList.setAttribute('hidden', true);
        });
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
